import React, { useEffect } from 'react'

// Bootstrap-styled modal driven by React state (no bootstrap JS needed)
const Modal = ({ show, onClose, children, size = '' }) => {
    useEffect(() => {
        if (!show) return
        const onKey = (e) => e.key === 'Escape' && onClose()
        document.addEventListener('keydown', onKey)
        document.body.classList.add('modal-open')
        return () => {
            document.removeEventListener('keydown', onKey)
            document.body.classList.remove('modal-open')
        }
    }, [show, onClose])

    if (!show) return null

    return (
        <>
            <div className="modal ModalBox show d-block" role="dialog" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
                <div className={`modal-dialog ${size}`}>
                    <div className="modal-content">
                        <div className="modal-body">
                            <button type="button" className="CloseModal" onClick={onClose} aria-label="Close">×</button>
                            {children}
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show" />
        </>
    )
}

export const ConfirmModal = ({ show, title, message, onCancel, onConfirm, busy }) => (
    <Modal show={show} onClose={onCancel}>
        <div className="Decline">
            <h3>{title}</h3>
            <p>{message}</p>
            <h4>
                <button type="button" className="Button Cancel" onClick={onCancel} disabled={busy}>Cancel</button>
                <button type="button" className="Button Danger ml-2" onClick={onConfirm} disabled={busy}>
                    {busy ? 'Deleting...' : 'Delete'}
                </button>
            </h4>
        </div>
    </Modal>
)

export default Modal
